import React from 'react'
import Input from '../../components/UI/Input'
import useInput from '../../hooks/input.hook'
import useAdminApi from '../../API/admin.api'
import useAlert from '../../hooks/alert.hook'

import styles from '../../styles/pages/createPayment.module.css'


function CreatePayment() {
    const adminApi = useAdminApi()
    const Alert = useAlert()

    const amount = useInput(0)
    const card = useInput('')

    const createHandler = async () => {
        const res = await adminApi.createPayment(amount.value, card.value)
        if(res) { Alert.pushMess('Payment has bin created') }
    }

    return (
        <div className={styles.main}>
            <div className={styles.form}>
                <Input input={card} placeholder='Card Number'/>
                <Input input={amount} placeholder='Amount' />
                <button onClick={() => createHandler()} className={styles.button}>Create</button>
            </div>
        </div>
    )
}

export default CreatePayment